<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">系统</Breadcrumb-item>
        <Breadcrumb-item>权限菜单列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="50" :show-message="false" label-position="left">
        <Row :gutter="32">
          <i-col span="6">
            <Form-item label="分类" prop="nickname">
              <Select @on-change="onSearchPidChange" clearable>
                <Option v-for="item in parentRules" :value="item.id" :key="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col span="6">
            <Form-item label="子分类" prop="mobile">
              <Select @on-change="onSearchSubPidChange" clearable>
                <Option v-for="item in searchSubRules" :value="item.id" :key="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col span="6">
            <Form-item label="路径" prop="name">
              <Input v-model="queryParam.name"/>
              <input type="text" style="display: none">
            </Form-item>
          </i-col>
          <i-col span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索
            </Button>
          </i-col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button
        type="primary"
        icon="plus-round"
        @click="onEdit('')">添加权限
      </Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/adminRule/list"
          :params="queryParam" :onLoading="onLoading" :onSelection="onSelection"></List>

    <Modal title="编辑" v-model="editModal">
      <Form ref="form" class="form" :model="formData" :rules="formRule" :label-width="80">
        <Row>
          <i-col :span="22">
            <Form-item label="名称" prop="title">
              <Input v-model="formData.title"/>
            </Form-item>
          </i-col>
          <i-col :span="22">
            <Form-item label="URL" prop="name">
              <Input v-model="formData.name"/>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="分类" prop="pid">
              <Select v-model.number="pid" @on-change="onPidChange">
                <Option v-for="item in parentRules" :value="item.id" :key="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="子分类">
              <Select v-model.number="subPid" @on-change="onSubPidChange">
                <Option v-for="item in subRules" :value="item.id" :key="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="类型" prop="type">
              <Select v-model.number="formData.type">
                <Option v-for="item in adminRuleTypes" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </i-col>

          <i-col :span="11">
            <Form-item label="状态" prop="status">
              <Select v-model.number="formData.status">
                <Option v-for="item in statusList" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="18">
            <Form-item label="排序" prop="sort">
              <Input v-model="formData.sort"></Input>
            </Form-item>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="editModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingEdit" @click="edit">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    data () {
      let $constant = this.$constant
      let self = this
      return {
        searchLoading: false,
        reload: 0,
        searchSubRules: [],
        queryParam: {
          pid: null,
          name: ''
        },
        pid: null,
        subPid: null,
        childId: null,
        parentRules: [],
        subRules: [],
        statusList: $constant.enabledStatus,
        adminRuleTypes: $constant.adminRuleType,
        loadingEdit: false,
        editModal: false,
        formData: {
          id: '',
          title: '',
          name: '',
          pid: '',
          type: '',
          status: 1,
          sort: 0,
//          parent: '',
        },
        formRule: {},
        title: [
          {
            title: '名称',
            align: 'center',
            key: 'title'
          },
          {
            title: 'URL',
            align: 'center',
            key: 'name'
          },
          {
            title: '分类',
            align: 'center',
            key: 'pid'
          },
          {
            title: '类型',
            key: 'type',
            align: 'center',
            render: (h, params) => {
              let type = $constant.getEnum($constant.adminRuleType, params.row.type)
              return h('span', type && type.text)
            }
          },
          {
            title: '状态',
            key: 'status',
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let color = status === 0 ? 'red' : ''
              let statusEnum = $constant.getEnum($constant.enabledStatus, status)
              return h('span', {style: {color: color}}, statusEnum && statusEnum.text)
            }
          },
          {
            title: '排序',
            key: 'sort',
            align: 'center',
          },
          {
            title: '操作',
            // width: 150,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      self.onEdit(params.row)
                    }
                  }
                }, '编辑')
              ])
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      this.init()
    },
    computed: {},
    methods: {
      init () {
        this.$http.get('/adminRule/list', {params: {pid: 0, pageIndex: 1, pageSize: 1000}}).
          then(res => {
            if (res && res.data) {
              this.parentRules = res.data.data
            }
          })
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      onSelection (selection) {
        this.selection = selection
      },
      delAll () {
        this.$refs.dataList.delAll()
      },
      onEdit (row) {
        let self = this
        // self.pid = null
        self.subPid = null
        if (!row) {
          self.formData = {
            id: '',
            title: '',
            name: '',
            pid: '',
            type: '',
            status: 1,
            sort: 0,
//          parent: ''
          }
          self.editModal = true
          return
        }
        self.formData.id = row.id
        self.formData.title = row.title
        self.formData.name = row.name
        self.formData.pid = row.pid
        self.formData.type = row.type
        self.formData.status = row.status
        self.formData.sort = row.sort
        if (!row.pid || row.pid === 0) {
          self.editModal = true
          return
        }
        self.getParent(row.pid)
        self.editModal = true
      },
      getParent (pid) {
        let self = this
        if (!pid || pid === 0) {
          self.pid = ''
          self.subPid = ''
          return
        }

        self.$http.get('/adminRule/queryById', {params: {id: pid}}).then(res => {
          if (res && res.data) {
            if (res.data.pid === 0) {
              self.pid = pid
              self.subPid = ''
            } else {
              self.pid = res.data.pid
              self.subPid = pid
            }
          }
        })
      },
      edit () {
        let self = this
        self.loadingEdit = true
        self.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingEdit = false
            return
          }
          let path = '/adminRule/saveAdminRule'
          self.$http.post(path, self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.editModal = false
              self.$Message.success('提交成功!')
            }
            self.loadingEdit = false
            self.search()
          })
        })
      },
      onPidChange (value) {
        this.formData.pid = value
        this.$http.get('/adminRule/list', {params: {pid: value}}).then(res => {
          if (res && res.data) {
            this.subRules = res.data.data
          } else {
            this.subRules = []
          }
        })
      },
      onSubPidChange (value) {
        this.formData.pid = value
      },
      onSearchPidChange (value) {
        this.queryParam.pid = value
        this.$http.get('/adminRule/list', {params: {pid: value}}).then(res => {
          if (res && res.data) {
            this.searchSubRules = res.data.data
          } else {
            this.searchSubRules = []
          }
        })
      },
      onSearchSubPidChange (value) {
        this.queryParam.pid = value
      }

    },
    watch: {
      // subRules (val) {
      //   if (val && val.length > 0) {
      //     this.subPid = this.childId
      //   }
      // }
    },
  }

</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// AdminRuleList.vue?7730e17c